import { AnyAction, combineReducers } from 'redux'
import { PatientAlertsApi } from './alerts/api'
import authReducer, { removeToken } from './auth/authReducer'
import doctorReducer from './doctor/doctorReducer'
import nurseReducer from './nurse/nurseReducer'
import patientReducer from './patient/patientReducer'
import patientAdmissionReducer from './patientAdmission/patientAdmissionReducer'
import { PatientAdmissionsMewsScoreApi } from './patientAdmissionMews/api'
import patientAlertConfigurationReducer from './patientAlertConfiguration/patientAlertConfigurationReducer'
import patientPrescriptionReducer from './patientPrescription/patientPrescriptionReducer'
import patientSmsLogsReducer from './patientSmsLogs/patientSmsLogsReducer'
import recordedDataReducer from './recordedData/recordedDataReducer'
import { RecordedEcgSignalsApi } from './recordedEcgSignals/api'
import recordedEcgWindowReducer from './recordedEcgWindow/recordedEcgWindowReducer'
import { RecordedEcgArrhythmiaSignalsApi } from './recordedEcgArrhythmiaSignals/api'
import recordedEcgArrhythmiaWindowReducer from './recordedEcgArrhythmiaWindow/recordedEcgArrhythmiaWindowReducer'
import singlePatientAlertReducer from './singlePatientAlert/singlePatientAlertReducer'
import visualizationDataReducer from './visualizationData/visualizationDataReducer'
import addsDataReducer from './addsData/addsDataReducer'

const appReducer = combineReducers({
  patientAdmissionDataState: patientAdmissionReducer,
  patientDataState: patientReducer,
  doctorState: doctorReducer,
  nurseState: nurseReducer,
  singlePatientAlertState: singlePatientAlertReducer,
  patientSmsLogsState: patientSmsLogsReducer,
  patientPrescriptionState: patientPrescriptionReducer,
  authState: authReducer,
  patientRecordedDataState: recordedDataReducer,
  patientRecordedEcgWindowState: recordedEcgWindowReducer,
  patientRecordedEcgArrhythmiaWindowState: recordedEcgArrhythmiaWindowReducer,
  patientAlertConfiguration: patientAlertConfigurationReducer,
  [PatientAlertsApi.reducerPath]: PatientAlertsApi.reducer,
  [PatientAdmissionsMewsScoreApi.reducerPath]:
    PatientAdmissionsMewsScoreApi.reducer,
  [RecordedEcgSignalsApi.reducerPath]: RecordedEcgSignalsApi.reducer,
  [RecordedEcgArrhythmiaSignalsApi.reducerPath]: RecordedEcgArrhythmiaSignalsApi.reducer,
  visualizationDataState: visualizationDataReducer,
  addsDataState: addsDataReducer,
})

// TODO: define type properly
const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === removeToken.type) {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
